import React, { useContext, useState } from "react";
import { CompactPicker } from "react-color";
import { State } from "../context/State";
import { getLayerColor, saveState } from "./util";

const cover = {
  position: "fixed",
  top: "0px",
  right: "0px",
  bottom: "0px",
  left: "0px"
};

export const LayerColorPicker = ({ layer, float, size, style }) => {
  const { metaLookup, setLayerProp } = useContext(State);
  const color = getLayerColor(metaLookup, layer);
  const [colorPicker, setColorPicker] = useState(false);
  const handleChangeComplete = e =>
    setLayerProp(layer, { lineColor: e.hex }, state => saveState(state));

  return (
    <div>
      <div
        onClick={() => setColorPicker(true)}
        style={{
          height: size || 16,
          width: size || 16,
          borderRadius: 3,
          backgroundColor: color,
          float: float || "right",
          border: "1px solid #d6d6d6",
          ...style
        }}
      />
      {colorPicker ? (
        <div style={{ position: "absolute", zIndex: 10 }}>
          <div
            style={cover}
            onClick={() => {
              setColorPicker(false);
            }}
          />
          {colorPicker ? (
            <CompactPicker
              color={color}
              onChange={handleChangeComplete}
              onChangeComplete={() => setColorPicker(false)}
            />
          ) : null}
        </div>
      ) : (
        <div />
      )}
    </div>
  );
};
